import styled from 'styled-components';
import { ReactComponent as RawSearchSVG } from '../../../../assets/icons/icon_search.svg';

export const IconSearch = styled(RawSearchSVG)``;
